<template>
    <div id="searchList">
        <search-list></search-list>
    </div>
</template>
<script>
    import SearchList from 'searchList'
    export default {
        components:{
            SearchList
        },
        data: function () {
            return {

            }
        }
    }
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/information/searchList/SearchList.vue